import axiosInstance from "../Middleware/interceptor";

export const postApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.post(`${url}`, data, config);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getApi = async (url, config = {}) => {
  try {
    const response = await axiosInstance.get(`${url}`, config);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const putApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.put(`${url}`, data, config);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const patchApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.patch(`${url}`, data, config);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteApi = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(`${url}`, config);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const login = (credentials) => postApi("/api/auth/login", credentials);

export const resetPassword = ({ token, password }) =>
  postApi("/api/auth/reset-password", { token, password });

export const forgotPassword = ({ email }) =>
  postApi("/api/auth/forgot-password", { email });

export const setPassword = ({ token, password }) =>
  postApi("/api/auth/set-password", { token, password });

export const logout = () => postApi("/api/auth/logout");

export const refreshToken = () => postApi("/api/auth/refresh-token", {});

export const getProfile = () => getApi("/api/auth/profile");

export const updateUserProfile = (data) => patchApi("/api/auth/profile", data);

export const changePassword = ({ current_password, new_password }) =>
  patchApi("/api/auth/change-password", { current_password, new_password });

export const createAppointment = (data) => postApi("/api/appointment", data);

export const getAppointments = ({ status, page = 1, pageSize = 20 } = {}) =>
  getApi("/api/admin/appointments", {
    params: { status, page, pageSize },
  });

export const getContacts = ({ status, page = 1, pageSize = 20 } = {}) =>
  getApi("/api/admin/contacts", {
    params: { status, page, pageSize },
  });

export const PARTNERSHIP_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  SUSPENDED: "suspended",
};

export const getPartnerships = ({ status, page = 1, pageSize = 20 } = {}) =>
  getApi("/api/admin/partnerships", {
    params: { status, page, pageSize },
  });

export const getPartnershipById = (id) => getApi(`/api/admin/partnerships/${id}`);

export const updatePartnershipStatus = (id, status) =>
  patchApi(`/api/admin/partnerships/${id}/status`, { status });

export const updateAppointmentStatus = (id, status) =>
  patchApi(`/api/admin/appointments/${id}/status`, { status });

export const getSimRequests = ({
  status,
  search,
  startDate,
  endDate,
  page = 1,
  pageSize = 20,
} = {}) =>
  getApi("/api/admin/esims/sim-requests", {
    params: { status, search, startDate, endDate, page, pageSize },
  });

export const getSimRequestStats = ({ provider_id, startDate, endDate } = {}) =>
  getApi("/api/admin/esims/sim-requests/stats", {
    params: { provider_id, startDate, endDate },
  });

export const getAdminEsims = ({
  status,
  provider_id,
  search,
  startDate,
  endDate,
  page = 1,
  pageSize = 20,
} = {}) =>
  getApi("/api/admin/esims", {
    params: { status, provider_id, search, startDate, endDate, page, pageSize },
  });

export const getAdminEsimStats = ({ provider_id, startDate, endDate } = {}) =>
  getApi("/api/admin/esims/stats", {
    params: { provider_id, startDate, endDate },
  });

export const approveSimRequest = (id) =>
  patchApi(`/api/admin/esims/sim-requests/${id}/approve`);

export const rejectSimRequest = (id, { note }) =>
  patchApi(`/api/admin/esims/sim-requests/${id}/reject`, { note });

export const getProviderSimRequests = ({
  status,
  search,
  startDate,
  endDate,
  page = 1,
  pageSize = 20,
} = {}) =>
  getApi("/api/provider/sim-requests", {
    params: { status, search, startDate, endDate, page, pageSize },
  });

export const getProviderSimRequestStats = ({ startDate, endDate } = {}) =>
  getApi("/api/provider/sim-requests/stats", {
    params: { startDate, endDate },
  });

export const createProviderSimRequest = ({ quantity, note }) =>
  postApi("/api/provider/sim-requests", { quantity, note });

export const getProviderEsims = ({
  assigned,
  status,
  search,
  startDate,
  endDate,
  page = 1,
  pageSize = 20,
} = {}) =>
  getApi("/api/provider/esims", {
    params: { assigned, status, search, startDate, endDate, page, pageSize },
  });

export const getProviderEsimStats = ({ startDate, endDate } = {}) =>
  getApi("/api/provider/esims/stats", {
    params: { startDate, endDate },
  });

export const syncProviderEsims = () => postApi("/api/provider/esims/sync", {});

export const getCustomers = ({
  provider_id,
  status,
  search,
  startDate,
  endDate,
  page = 1,
  pageSize = 20,
} = {}) =>
  getApi("/api/admin/customers", {
    params: { provider_id, status, search, startDate, endDate, page, pageSize },
  });

export const getCustomerStats = ({ provider_id, startDate, endDate } = {}) =>
  getApi("/api/admin/customers/stats", {
    params: { provider_id, startDate, endDate },
  });

export const getAdminOverview = ({ startDate, endDate } = {}) =>
  getApi("/api/admin/overview", {
    params: { startDate, endDate },
  });
